import { login } from "@/api/login/index";
const user = {
    state: {
        userData: {},//用户基本信息
        isLogin: false,//用户登录状态
        loginDialog: false,
        foreign: 1
    },
    mutations: {
        SET_FOREIFN(state, foreign) {
            state.foreign = foreign
        },
        SET_USER_DATA: (state, userData) => {
            window.localStorage.setItem(
                "userData",
                JSON.stringify(userData)
            );
            state.userData = userData
        },
        //设置Vuex登录状态
        SET_IS_LOGIN: (state, isLogin) => {
            if (!isLogin) {
                window.localStorage.removeItem("token"); //删除本地旧token
                window.localStorage.removeItem("userData"); //删除本地旧数据
                location.reload(); //重新刷新页面
                this.$message({
                    message: "成功退出登录",
                    type: "success",
                });
            }
            state.isLogin = isLogin
        },
    },
    actions: {
        login({ commit }, userForm) {
            return new Promise((resolve, reject) => {
                login(userForm).then(response => {
                    const res = response.data;
                    if (1 == res.code) {
                        window.localStorage.setItem('token', res.data.token)//将token存入本地
                        window.localStorage.setItem('userData', JSON.stringify(res.data))//将用户基本信息存入本地
                        commit('SET_IS_LOGIN', true)//修改登录状态
                        commit('SET_USER_DATA', res.data)//修改用户信息
                    }
                    resolve(res)
                }).catch((error) => {
                    reject(error)
                })
            })
        }
    },
}


export default user